module.exports = __webpack_public_path__ + "static/media/36-10.82738a82.mp3";